import MuiDrawer from '@mui/material/Drawer';
import { useCallback, useContext, useRef } from 'react';

import { qDrawerName } from './constants';
import { ApplicationContext } from '../../../../../shared/source/context/context';

import type { FunctionComponent, PropsWithChildren } from 'react';

export const useAppDrawer = (): { readonly closeAppDrawer: () => void; readonly currentDrawer: string | null } => {
    const {
        actions: { setLocationSearchParams },
        applicationState: { location, locationSearchParams },
    } = useContext(ApplicationContext);
    const { pathname } = location;
    const searchParamsRef = useRef(locationSearchParams);
    const pathnameRef = useRef(pathname);

    searchParamsRef.current = locationSearchParams;
    pathnameRef.current = pathname;

    const closeAppDrawer = useCallback(() => {
        const params = searchParamsRef.current;
        [...searchParamsRef.current].forEach(([searchKey]) => {
            if (searchKey.startsWith('qDrawer')) {
                params.delete(searchKey);
            }
        });
        setLocationSearchParams(params, { replace: true });
    }, [setLocationSearchParams]);

    const currentDrawer = locationSearchParams.get(qDrawerName);

    return { closeAppDrawer, currentDrawer };
};

export const AppDrawer: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { applicationState } = useContext(ApplicationContext);
    const { closeAppDrawer } = useAppDrawer();

    const handleClose = useCallback(() => {
        closeAppDrawer();
    }, [closeAppDrawer]);

    const isDrawerOpen = Boolean(applicationState.locationSearchParams.get(qDrawerName));

    return (
        <MuiDrawer
            anchor="right"
            open={isDrawerOpen}
            PaperProps={{ sx: { width: '66vw', zIndex: 1 } }}
            role="dialog"
            onClose={handleClose}
        >
            {children}
        </MuiDrawer>
    );
};
